import { render, staticRenderFns } from "./RevenueReduction.vue?vue&type=template&id=0bf98caf&scoped=true&"
import script from "./RevenueReduction.vue?vue&type=script&lang=js&"
export * from "./RevenueReduction.vue?vue&type=script&lang=js&"
import style0 from "./RevenueReduction.vue?vue&type=style&index=0&id=0bf98caf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf98caf",
  null
  
)

export default component.exports